<template>
  <div class="container">
    <div class="wapper">
      <div class="home_pendant">
        <div class="tipAi" v-if="aiFlag">
          <i @click="aiFlag = false" class="el-icon-close"></i>
          <div>
            <p>配合资源助手，更智能</p>
            <p @click="toAi" class="tip_a">速速体验</p>
          </div>
        </div>
        <div class="stateHome">
          <ul>
            <li>
              <img src="../../assets/images/icon-sj-ry.png" alt="" />
              <div class="state-right">
                <p>{{ researcher }}</p>
                <p>科研人员</p>
              </div>
            </li>
            <li>
              <img src="../../assets/images/icon-sj-cg.png" alt="" />
              <div class="state-right">
                <p>{{ leftPaper }}</p>
                <p>论文成果</p>
              </div>
            </li>
            <li>
              <img src="../../assets/images/icon-sj-zs.png" alt="" />
              <div class="state-right">
                <p>{{ concept }}</p>
                <p>知识概念</p>
              </div>
            </li>
            <li>
              <img src="../../assets/images/icon-sj-yy.png" alt="" />
              <div class="state-right">
                <p>{{ referenced }}</p>
                <p>引用关系</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 修改后 -->
      <div
        class="sys-name"
        v-if="
          sysName && sysName !== 'null' && sysName !== null && sysName !== ''
        "
      >
        {{ sysName }}
      </div>
      <div class="img" v-else>
        <img src="../../assets/images/jyx.png" />
      </div>

      <div class="img"><img src="../../assets/images/ai.png" alt="" /></div>
      <div class="main-flex">
        <div class="left">
          <ul>
            <li>
              <img src="../../assets/images/icon-jiansuo.png" alt="" />
            </li>
            <li
              class="point"
              @click="handleChangeTab(1)"
              :class="{ checked: tabIndex == 1 }"
            >
              文献
            </li>
            <li
              class="point"
              @click="handleChangeTab(2)"
              :class="{ checked: tabIndex == 2 }"
            >
              AI学术搜索
            </li>
            <li
              class="point"
              @click="handleChangeTab(3)"
              :class="{ checked: tabIndex == 3 }"
            >
              学者搜索
            </li>
            <li></li>
            <!-- <li @click="handleChangeTab(3)" :class="{ checked: tabIndex == 3 }">Topics<img src="../../assets/images/new.png" /></li> -->
            <!-- <li></li> -->
          </ul>
        </div>
        <div class="right">
          <div class="item-one page1" v-if="tabIndex == 1">
            <div class="flex">
              <el-input
                placeholder="请输入要检索的内容"
                v-model="keyword"
                maxlength="100"
                @keyup.enter.native="toSearch"
                @input="getKeywordData(1)"
                @focus="showSearchInput"
                @blur="hideSearchInput"
                clearable
              ></el-input>
            </div>
            <img
              class="search-btn"
              src="../../assets/images/search-btn.png"
              alt=""
              @click="toSearch"
            />
          </div>
          <div class="hot" v-if="tabIndex == 1">
            <img src="../../assets/images/icon-hot.png" />
            <span class="hot-title">热门检索词：</span>
            <ul>
              <li v-for="(item, index) in hotList" :key="index">
                <span @click="toHotSearch(item)">{{ item }}</span>
              </li>
            </ul>
          </div>
          <div
            class="item-one page1"
            v-if="tabIndex == 2"
            style="margin-top: 60px"
          >
            <div class="flex">
              <el-input
                placeholder="请输入要检索的内容"
                v-model="AIkeyword"
                maxlength="100"
                @keyup.enter.native="AItoSearch()"
                clearable
              ></el-input>
            </div>
            <img
              class="search-btn"
              src="../../assets/images/search-btn.png"
              alt=""
              @click="AItoSearch()"
            />
          </div>
          <div class="aihot" v-if="tabIndex == 2" v-loading="tab2text">
            <div
              class="hotitem"
              v-for="(item, index) in AIhotlist"
              :key="index"
            >
              <div class="question" @click="AItoSearch(item)">{{ item }}</div>
              <div class="arrow" @click="AItoSearch(item)"></div>
            </div>
          </div>
          <!-- <div class="page2" v-if="tabIndex == 2">
            <el-input type="textarea" placeholder="支持智能语义检索" maxlength="700" :rows="14" v-model="keyword" @input="handleWriteKeywords" show-word-limit @keyup.enter.native="toSearch"></el-input>
          </div> -->
          <div class="item-one page1" v-if="tabIndex == 3">
            <div class="flex">
              <el-input
                placeholder="请输入要检索的内容"
                v-model="authorKeyword"
                maxlength="100"
                @keyup.enter.native="toSearch"
                @input="getKeywordData(3)"
                @focus="showSearchInput"
                @blur="hideSearchInput"
                clearable
              ></el-input>
            </div>
            <img
              class="search-btn"
              src="../../assets/images/search-btn.png"
              alt=""
              @click="toSearch"
            />
          </div>
          <!-- 检索 -->
          <div class="searchBtn">
            <el-popover
              placement="top-start"
              width="285"
              trigger="hover"
              :content="tipsContent"
            >
              <i slot="reference" class="el-icon-warning"></i> </el-popover
            >检索提示
          </div>
          <!-- 智能搜索 -->
          <!-- <div class="znButton" v-if="tabIndex == 2">
            <el-button type="primary" @click="toSearch">搜索</el-button>
          </div> -->
          <div class="search-input" v-if="searchFlag" @click.stop>
            <ul>
              <li
                v-for="(item, index) in keywordDataList"
                :key="index"
                @click="toSearchKeyword(index)"
                v-html="item.suggestionWord"
              ></li>
            </ul>
          </div>
        </div>
        <!-- 底部阴影 -->
        <img
          class="shadow"
          src="../../assets/images/search-shadow.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl";
export default {
  name: "ArticleSearch",
  data() {
    return {
      value: 1,
      aiFlag: true,
      options: [
        {
          value: 1,
          label: "分词检索",
        },
        {
          value: 2,
          label: "智能检索",
        },
      ],
      // 新增联想词功能相关数据
      searchFlag: false, // 控制联想词列表显示隐藏
      keywordDataList: [], // 存储联想词数据
      selectVal: "",
      searchPaperOptions: [
        { label: "全部", value: null },
        { label: "题名", value: "title" },
        { label: "DOI", value: "doi" },
        { label: "作者", value: "author" },
        // { label: "作者机构", value: "authorOrg" },
        { label: "关键词", value: "hingeWord" },

        // { label: "摘要", value: "digest" },
      ],
      paper: "",
      keyword: "",
      authorKeyword: "",
      pageItemList: [
        {
          searchField: null,
          searchWords: "",
          operation: "1",
        },
      ],
      operationList: [
        {
          value: "1",
          label: "与",
        },
        {
          value: "2",
          label: "或",
        },
      ],
      tabIndex: 1,
      hotList: [],
      researcher: "", //科研人员
      leftPaper: "", //论文成果
      concept: "", //知识概念
      referenced: "", //引用关系
      AIhotlist: [],
      AIkeyword: "",
      tipsContent: "",
      tab2text: true,
      username: "",
      loadingCheckTimer: null,
      sysName: "",
    };
  },
  created() {
    // 在组件创建时就设置loading为true，确保头尾组件能够显示
    if (this.$parent) {
      this.$parent.loading = true;
    }

    // 添加一个简单的定时器检查，确保loading始终为true
    this.loadingCheckTimer = setInterval(() => {
      if (this.$parent && !this.$parent.loading) {
        this.$parent.loading = true;
      }
    }, 500);
  },

  mounted() {
    // 组件挂载时，mixin会自动调用getInfo，这里不需要重复调用
    // 直接调用必要的初始化逻辑
    this.getHotList();
    this.getHomeCount();
    this.getTips();
    this.hotword();
    // 再次确保loading状态为true
    if (this.$parent) {
      this.$parent.loading = true;
    }
    if (localStorage.getItem("sysName")) {
      this.sysName = localStorage.getItem("sysName");
    } else if (localStorage.getItem("systemName")) {
      this.sysName = localStorage.getItem("systemName");
    }
  },

  // 组件销毁前清除定时器
  beforeDestroy() {
    if (this.loadingCheckTimer) {
      clearInterval(this.loadingCheckTimer);
    }
  },
  methods: {
    getTips() {
      this.$http({
        url: "api/v1/system/config/configKey/sys.tips.index",
        method: "GET",
      }).then((res) => {
        if (res.code == 200) {
          this.tipsContent = res.data;
        }
      });
    },
    getHomeCount() {
      this.$http({
        url: "api/v1/reception/journalpaper/homeCount",
        method: "GET",
      }).then((res) => {
        if (res.code == 200) {
          this.researcher = this.toThousands(res.data[0].count); //科研人员
          this.leftPaper = this.toThousands(res.data[1].count); //论文成果
          this.concept = this.toThousands(res.data[2].count); //知识概念
          this.referenced = this.toThousands(res.data[3].count); //引用关系
        }
      });
    },
    toThousands(num) {
      const result = [];
      let counter = 0;
      num = (num || 0).toString().split("");
      for (let i = num.length - 1; i >= 0; i--) {
        counter++;
        result.unshift(num[i]);
        if (!(counter % 3) && i !== 0) {
          result.unshift(",");
        }
      }
      return result.join("");
    },
    getHotList() {
      this.$http({
        url: "api/v1/reception/journalpaper/getTopSearchWords",
        method: "GET",
      }).then((res) => {
        if (res.code == 200) {
          this.hotList = res.data;
        }
      });
    },
    hotword() {
      this.$http({
        url: "api/v1/resource/ai-academic/questionRandom",
        method: "GET",
      }).then((res) => {
        if (res.code == 1) {
          this.AIhotlist = res.data;
          this.tab2text = false;
        }
      });
    },
    // 热门检索词
    toHotSearch(word) {
      sessionStorage.setItem(
        "search-keyword",
        JSON.stringify({
          word: word.trim(),
          paper: this.paper,
          searchType: this.tabIndex,
        })
      );
      this.keyword = "";

      this.$router.push({
        path: "/article",
      });
    },
    // 重写getInfo方法，确保调用mixin中的方法获取系统信息
    // getInfo() {
    //   // 先调用mixin中的getInfo方法获取系统信息
    //   const mixinGetInfo = this.$options.mixins.find(m => m.methods && m.methods.getInfo);
    //   if (mixinGetInfo) {
    //     mixinGetInfo.methods.getInfo.call(this).then(userInfo => {
    //       // 保留原有的用户名设置逻辑
    //       this.username = userInfo.userName;
    //       this.hotword();
    //     }).catch(() => {
    //       // 错误处理
    //       this.hotword();
    //     });
    //   } else {
    //     // 回退到原有逻辑
    //     this.$http({
    //       url: "api/v1/user/info",
    //       method: "POST",
    //     }).then((res) => {
    //       this.username = res.data.userName;
    //       this.hotword();
    //     });
    //   }
    // },
    AItoSearch(hotitem) {
      if (hotitem) {
        this.AIkeyword = hotitem;
      } else {
        if (!this.AIkeyword.trim()) {
          this.$message.error("请输入检索词");
          return;
        }
      }

      this.$http({
        url: "api/v1/resource/ai-academic/deleteHistory",
        method: "DELETE",
      }).then((res) => {
        if (res.code == 1) {
          sessionStorage.removeItem("search-answers");
          sessionStorage.setItem(
            "search-answers",
            JSON.stringify(this.AIkeyword)
          );
          this.$router.push({
            path: "/answers_list",
          });
        }
      });
    },
    toSearch() {
      // 文献检索   || 作者
      if (this.tabIndex == 1) {
        if (!this.keyword.trim()) {
          this.$message.error("请输入要检索的内容");
          return;
        }
      }
      if (this.tabIndex == 3) {
        if (!this.authorKeyword.trim()) {
          this.$message.error("请输入要检索的内容");
          return;
        }
      }
      // AI学术搜索
      if (this.tabIndex == 2) {
        if (!this.AIkeyword.trim()) {
          this.$message.error("请输入要检索的内容");
          return;
        }
      }
      sessionStorage.removeItem("search-keyword");
      let searchWords =
        this.tabIndex == 1 ? this.keyword.trim() : this.authorKeyword.trim();
      sessionStorage.setItem(
        "search-keyword",
        JSON.stringify({
          word: searchWords,
          paper: this.paper,
          searchType: this.tabIndex,
        })
      );
      this.keyword = "";
      this.authorKeyword = "";
      if (this.tabIndex == 1) {
        this.$router.push({
          path: "/article",
        });
      } else if (this.tabIndex == 2) {
        this.$router.push({
          path: "/intellIndex",
        });
      } else {
        this.$router.push({
          path: "/author",
        });
      }
    },
    keydown(e) {
      e.target.value = e.target.value.replace(
        /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g,
        ""
      );
    },
    keyUp(e) {
      e.target.value = e.target.value.replace(
        /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、 ]/g,
        ""
      );
    },
    toHeight() {
      this.$router.push({ path: "/search", query: { type: "article" } });
    },
    toAi() {
      let _url = this.$router.resolve({
        path: "/AiHelp",
      });
      window.open(_url.href, "_self");
    },
    handleChangeTab(index) {
      this.tabIndex = index;
      this.keyword = this.keyword.trim();
      this.authorKeyword = this.authorKeyword.trim();
    },
    // 分词检索 如果是第一个  把值赋给 智能检索 topics中
    // resertkeywords(val, index) {
    //   if (index == 0) {
    //     this.keyword = val;
    //   } else if (index == 1) {
    //     this.authorKeyword = val;
    //   }
    // },
    // 智能检索  topics输入  分词检索如果是高级检索 把值带到第一个里
    handleWriteKeywords(val) {
      if (this.pageItemList.length > 1) {
        this.pageItemList[0].searchWords = this.keyword;
      }
    },
    // 根据输入的内容获取联想数据
    getKeywordData(idx) {
      if (idx == 1) {
        this.selectVal = "";
      } else if (idx == 3) {
        this.selectVal = "author";
      }
      // 根据当前激活的tab选择对应的关键词
      const currentKeyword =
        this.tabIndex === 1 ? this.keyword : this.authorKeyword;
      if (!currentKeyword.trim()) {
        this.searchFlag = false;
        return;
      }
      let postBody = {
        word: currentKeyword,
        autoCompletionFieldName: this.selectVal,
      };
      this.$http({
        url: `api/v1/reception/journalpaper/suggestion`,
        method: "post",
        data: postBody,
      }).then((res) => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.searchFlag = false;
          } else {
            this.keywordDataList = res.data;
            this.searchFlag = true;
          }
        }
      });
    },

    // 点击联想关键词事件
    toSearchKeyword(index) {
      sessionStorage.removeItem("search-keyword");
      let searchWords = this.keywordDataList[index].suggestionWord
        .split("<span style='color:#15babc'>")
        .join("")
        .split("</span>")
        .join("");
      this.paper = this.tabIndex == 1 ? "" : "author";
      sessionStorage.setItem(
        "search-keyword",
        JSON.stringify({
          word: searchWords,
          paper: this.paper,
          searchType: 1,
        })
      );
      this.keyword = "";
      this.authorKeyword = "";
      if (this.tabIndex == 1) {
        this.$router.push({
          path: "/article",
        });
      } else {
        // 根据当前tab设置对应的关键词
        this.$router.push({
          path: "/author",
        });
      }
      this.searchFlag = false;
    },

    // 控制联想框显示
    showSearchInput() {
      if (
        (this.keyword || this.authorKeyword) &&
        this.keywordDataList.length > 0
      ) {
        this.searchFlag = true;
      }
    },

    // 控制联想框隐藏
    hideSearchInput() {
      // 使用setTimeout延迟隐藏，以便点击联想词时能触发点击事件
      setTimeout(() => {
        this.searchFlag = false;
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: calc(100vh - 154px);
  // min-height: calc(100vh - 154px);
  background: url("../../assets/images/bj2.png") no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  position: relative;
  min-height: 700px;
  .home_pendant {
    position: fixed;
    left: 30px;
  }
  .tipAi {
    width: 200px;
    height: 100px;
    background: url("../../assets/images/tishi.png") no-repeat;
    background-size: cover;
    color: #fff;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    .el-icon-close {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
      font-size: 16px;
    }
    .tip_a {
      cursor: pointer;
      text-decoration: underline;
      margin-top: 5px;
    }
  }
  .stateHome {
    margin-top: 5px;
    background: linear-gradient(
        45deg,
        rgba(0, 110, 179, 0.6) 0%,
        rgba(21, 186, 188, 0.6) 100%
      ),
      #f7f7f7;
    height: 240px;
    width: 200px;
    border-radius: 10px;
    border: 3px solid rgba(255, 255, 255, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    ul {
      li {
        display: flex;
        color: #fff;
        font-size: 14px;
        margin-bottom: 15px;
        &:last-of-type {
          margin: 0;
        }
        img {
          margin-right: 15px;
          width: 40px;
        }
        p {
          &:nth-of-type(1) {
            font-size: 16px;
          }
          &:nth-of-type(2) {
            color: rgba(255, 255, 255, 0.7);
          }
        }
      }
    }
  }
  .wapper {
    margin-top: 6%;
  }
  .img {
    text-align: center;
    margin-bottom: 30px;
  }
  .search {
    width: 900px;
    height: 68px;
    background: #ffffff;
    box-shadow: 0px 2px 8px 0px rgba(14, 144, 151, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
    display: none;

    .point {
      cursor: pointer;
      color: #2d8cf0;
    }
    .page {
      display: flex;
      align-items: center;
      .input-search {
        width: 660px;
        height: 52px;
        background: #ffffff;
        border: 1px solid rgba(14, 144, 151, 0.18);
        border-radius: 4px;
        margin: 0 10px;
        display: flex;
        align-items: center;
        .el-select {
          width: 120px;
          position: relative;
          &::before {
            position: absolute;
            right: -2px;
            top: 50%;
            width: 1px;
            height: 24px;
            margin-top: -12px;
            content: "";
            background: #006eb2;
          }
        }
        .el-input {
          flex: 1;
        }
        ::v-deep .el-input__inner {
          border: none;
          background: none;
        }
        .search-cion {
          margin-right: 20px;
          cursor: pointer;
        }
      }
    }
    .el-select {
      width: 130px;
    }
    ::v-deep .el-input__inner {
      height: 52px;
      border: 1px solid rgba(10, 148, 183, 0.2);
      font-size: 16px;
    }
  }
  .main-flex {
    box-shadow: 0px 0px 12px 0px rgba(169, 167, 164, 0.8);
    background: #fff;
    width: 1380px;
    display: flex;
    position: relative;
    z-index: 999;
    .shadow {
      position: absolute;
      bottom: -40px;
      left: -35px;
    }
    .left {
      width: 300px;
      z-index: 999;
      .point {
        cursor: pointer;
      }
      li {
        height: 80px;
        color: #333;
        font-size: 18px;
        text-align: center;
        line-height: 80px;
        &:nth-of-type(1) {
          background: #0a94c2;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: inherit;
        }
        &:nth-of-type(2) {
          background: #ceeff2;
        }
        &:nth-of-type(3) {
          background: #dcf3f5;
        }
        &:nth-of-type(4) {
          background: #e8f5f6;
          position: relative;
          img {
            position: absolute;
            right: 90px;
            top: 10px;
          }
        }
        &:nth-of-type(5) {
          background: #f2f9fa;
        }
      }
      .checked {
        background: #fff !important;
        font-weight: bold;
      }
    }
    .right {
      flex: 1;
      position: relative;
      z-index: 999;
      max-width: 1080px;
      ::-webkit-scrollbar {
        display: block;
        width: 3px; /* 定制滚动条的宽度 */
      }
      /* 定制滚动条滑块样式 */
      ::-webkit-scrollbar-thumb {
        background-color: #2d8cf0;
      }

      /* 定制滚动条按钮样式 */
      ::-webkit-scrollbar-button {
        background-color: #c1c1c1;
      }
      .page1 {
        padding: 0 60px;
        max-height: 280px;
        overflow-y: auto;
        .hidden {
          visibility: hidden;
        }
        ::v-deep .el-input__inner {
          font-size: 16px;
        }
      }
      .item-one {
        display: flex;
        align-items: center;
        margin-top: 90px;
        .flex {
          // border: 1px solid #cce8ef;
          // box-shadow: 0 2px 8px 0 rgba(14, 144, 151, 0.18);
          // border-radius: 4px;
          background: url("../../assets/images/jiansuo.png") no-repeat;
          width: 828px;
          height: 60px;
          align-items: center;
          flex: 1;
          .el-select {
            width: 120px;
            position: relative;
            ::v-deep .el-input__inner {
              text-align: center;
            }
          }
          .el-input {
            width: 98%;
          }
        }
        ::v-deep .el-input__inner {
          border: none;
          background: none;
          font-size: 18px;
        }
        .search-btn {
          cursor: pointer;
        }
      }
      .aihot {
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0px 60px;
        .hotitem {
          width: 49%;
          margin-bottom: 10px;
          background: #f2f9fa;
          padding: 15px 20px;
          display: flex;
          .question {
            cursor: pointer;
            color: #666;
            width: 400px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .arrow {
            cursor: pointer;
            background-image: url(../../assets/images/jinru-mr.png);
            width: 20px;
            height: 14px;
            margin: 10px 0px 12px 20px;
          }
        }
        .hotitem:hover .question {
          color: #2d8cf0;
        }
        .hotitem:hover .arrow {
          background-image: url(../../assets/images/jinru-xz.png);
        }
      }
      .hot {
        display: flex;
        color: #333;
        padding: 0 60px;
        font-size: 18px;
        margin-top: 30px;
        img {
          margin-right: 15px;
          width: 15px;
          height: 19px;
          margin-top: 3px;
        }
        .hot-title {
          margin-right: 10px;
          min-width: 108px;
        }
        ul {
          display: flex;
          flex-wrap: wrap;
          li {
            position: relative;
            margin-right: 40px;
            margin-bottom: 10px;
            &:nth-of-type(1) {
              margin-left: 0;
            }
            span {
              cursor: pointer;
              &:hover {
                color: #2d8cf0;
                text-decoration: underline;
              }
            }
            &::after {
              content: "";
              position: absolute;
              right: -20px;
              width: 1px;
              height: 18px;
              background: #ccc;
              top: 50%;
              margin-top: -9px;
            }
            &:last-of-type {
              &::after {
                display: none;
              }
            }
          }
        }
      }
      .item {
        align-items: center;
        margin-bottom: 20px;
        .el-select {
          margin-right: 10px;
          width: 132px;
        }
        ::v-deep .el-input__inner {
          border-radius: 0;
        }
        .el-input {
          width: 610px;
        }
      }
      .searchBtn {
        position: absolute;
        bottom: 30px;
        left: 60px;
        display: flex;
        align-items: flex-end;
        color: #999999;
        font-size: 16px;
        align-items: center;
        > span {
          margin-right: 15px;
          color: #ccc;
        }
      }
      .znButton {
        position: absolute;
        bottom: 20px;
        right: 53px;
        .el-button {
          border-radius: 0;
          margin-left: 30px;
          font-size: 18px;
          width: 90px;
          height: 46px;
        }
      }
      .page2 {
        background: url("../../assets/images/znjs-kuang.png") no-repeat;
        width: 968px;
        height: 230px;
        margin-left: 60px;
        margin-top: 60px;
        padding: 10px;
        ::v-deep textarea {
          resize: none;
        }

        ::v-deep .el-textarea__inner {
          border: none;
          background: none;
          height: 220px;
          font-size: 16px;
          color: #666;
        }
        ::v-deep .el-input__count {
          display: none;
        }
      }
    }
  }
  @media only screen and (max-width: 1850px) {
    .main-flex {
      width: 1200px;
      .left {
        width: 200px;
      }
      .right {
        .item-one {
          .flex {
            width: 700px;
            background-size: 100%;
            margin-right: 20px;
            height: 55px;
          }
        }
      }
      .shadow {
        width: 1260px;
        left: -31px;
        bottom: -35px;
      }
    }
  }
  @media only screen and (max-width: 1600px) {
    .main-flex {
      width: 1100px;
      .left {
        width: 200px;
      }
      .right {
        .item-one {
          .flex {
            height: 50px;
            width: 600px;
            background-size: 100%;
            margin-right: 20px;
          }
          .search-btn {
            width: 100px;
          }
        }
      }
      .shadow {
        width: 1155px;
        left: -28px;
        bottom: -33px;
      }
    }
  }
}
/* 联想词弹出层样式 */
.search-input {
  position: absolute;
  top: 150px;
  left: 60px;
  width: 76%;
  max-height: 300px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  ul {
    margin: 0;
    padding: 0;
    li {
      padding: 8px 16px;
      cursor: pointer;
      transition: background-color 0.2s;
      &:hover {
        background-color: #f5f7fa;
      }
    }
  }
}
.sys-name {
  font-size: 40px;
  font-weight: bold;
  background-image: linear-gradient(to right, #006eb3, #2d8cf0);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 100px;
  text-align: center;
}
</style>
<style lang="scss">
// .el-select-dropdown .el-select-dropdown__item {
//   font-size: 16px;
// }

.el-popover {
  white-space: pre-wrap;
}
</style>